import { Spin } from "antd";

const Spinner = () => <Spin size="medium" />;

export default Spinner;
